/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Skip_UpdateInputs */



/**
* | output |
* | --- |
* | "Skip Update" |
*
* @param {Skip_UpdateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const skip_update = /** @type {((inputs?: Skip_UpdateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Skip_UpdateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ignorer la mise à jour")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktualisierung überspringen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salta l'aggiornamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пропустить обновление")
	if (locale === "es") return /** @type {LocalizedString} */ ("Omitir actualización")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("跳过更新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("更新をスキップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपडेट छोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pular atualização")
	return /** @type {LocalizedString} */ ("Skip Update")
});